// extracted by mini-css-extract-plugin
export var checkbox = "_5w-0";
export var circle = "_5w-3";
export var horizontalContainer = "_5w-7";
export var sm = "_5w-5";
export var switch0 = "_5w-2";
export var switchDisabled = "_5w-8";
export var switchEnabled = "_5w-1";
export var textSwitchContainer = "_5w-9";
export var textSwitchOption = "_5w-a";
export var textSwitchOptionSelected = "_5w-b";
export var verticalContainer = "_5w-6";
export var xs = "_5w-4";